<template>
  <div class="cta-section">
    <div class="container-fluid px-0">
      <div class="cta-content">
        <h2 class="cta-title">{{ title }}</h2>
        <p class="cta-text">{{ text }}</p>
        <div class="cta-buttons">
          <a href="tel:+37061692311" class="cta-btn-primary">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            <span>SKAMBINKITE DABAR</span>
          </a>
          <button @click="scrollToContact" class="cta-btn-secondary">
            <span>GAUTI PASIŪLYMĄ</span>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue'

export default {
  name: 'CTASection',
  props: {
    title: {
      type: String,
      default: 'Paruošti pradėti?'
    },
    text: {
      type: String,
      default: 'Susisiekite su mumis dar šiandien ir gaukite nemokamą konsultaciją'
    }
  },
  methods: {
    scrollToContact() {
      nextTick(() => {
        const contactId = document.getElementById('contact') || document.getElementById('kontaktai')
        if (contactId) {
          contactId.scrollIntoView({ behavior: 'smooth' })
        }
      })
    }
  }
}
</script>

<style scoped>
.cta-section {
  background: linear-gradient(135deg, #dc3545 0%, #ff6b6b 100%);
  padding: 60px 20px;
  position: relative;
  overflow: hidden;
}

.cta-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg width="100" height="100" xmlns="http://www.w3.org/2000/svg"><defs><pattern id="grid" width="100" height="100" patternUnits="userSpaceOnUse"><path d="M 100 0 L 0 0 0 100" fill="none" stroke="rgba(255,255,255,0.05)" stroke-width="1"/></pattern></defs><rect width="100%" height="100%" fill="url(%23grid)"/></svg>');
  opacity: 0.3;
}

.cta-content {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  z-index: 1;
}

.cta-title {
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(1.75rem, 4vw, 2.5rem);
  font-weight: 800;
  color: white;
  margin-bottom: 16px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.cta-text {
  font-family: 'Open Sans', sans-serif;
  font-size: clamp(1rem, 2vw, 1.2rem);
  color: rgba(255, 255, 255, 0.95);
  margin-bottom: 32px;
  line-height: 1.6;
}

.cta-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.cta-btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: white;
  color: #dc3545;
  padding: 16px 36px;
  border-radius: 50px;
  text-decoration: none;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.cta-btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
  color: #dc3545;
  text-decoration: none;
}

.cta-btn-primary svg {
  width: 20px;
  height: 20px;
}

.cta-btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  color: white;
  padding: 16px 36px;
  border-radius: 50px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

.cta-btn-secondary:hover {
  transform: translateY(-3px);
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.6);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.cta-btn-secondary svg {
  width: 20px;
  height: 20px;
  transition: transform 0.3s ease;
}

.cta-btn-secondary:hover svg {
  transform: translateX(3px);
}

@media (max-width: 768px) {
  .cta-section {
    padding: 50px 15px;
  }
  
  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .cta-btn-primary,
  .cta-btn-secondary {
    width: 100%;
    max-width: 300px;
    justify-content: center;
  }
}
</style>

